import { VariantOptionFacet, decorateCheckboxFacet } from '@process-creative/slate-ajax-collection';
import { t } from '@process-creative/slate-theme-tools';
import {CLASS_HIDDEN} from '../../../tools/constants/classes';
import FilterUtils from '../../../utils/FilterUtils';

// SELECTOR
const SELECTOR_CLEAR_FILTERS = '[data-collection-template-clear-filters]';  

const VariantOptionCheckboxFacet = decorateCheckboxFacet(VariantOptionFacet);

export class CustomVariantOptionFacet extends VariantOptionCheckboxFacet {
  constructor(params) {
    super(params);  
  }

  getClearButton(clazz) {
    return `
      <button
        class="${clazz} o-link"
        data-clear-filter="${this.filter.handle}">
        ${t('collections.filter.clear')}
      </button>`;
  }

  /**
   * Generate HTML for variant option checkboxes (e.g., Size options)
   * Shows product count for each variant option
   */
  getPrint() {
    let options = [];
    try {
      options = this.getOptionsToDraw ? this.getOptionsToDraw() || [] : [];
    } catch (error) {
      console.error('[CustomVariantOptionFacet] Failed to get options to draw');
      options = [];
    }

    const templateData = this.template && this.template.data ? this.template.data : null;
    const productsSource = templateData && Array.isArray(templateData.products)
      ? templateData.products
      : [];

    if (options.length === 0 && productsSource.length > 0) {
      const fallbackOptionNames = Array.isArray(this.optionNames) ? this.optionNames : [];
      const fallbackOptions = [];

      productsSource.forEach(product => {
        if (!product || !Array.isArray(product.variants)) return;

        const productOptionNames = Array.isArray(product.options) ? product.options : [];

        fallbackOptionNames.forEach(targetName => {
          if (!targetName) return;

          const optionIndex = productOptionNames.findIndex(optionName => {
            return typeof optionName === 'string' && optionName.toLowerCase() === targetName.toLowerCase();
          });

          if (optionIndex === -1) return;

          product.variants.forEach(variant => {
            if (!variant || !Array.isArray(variant.options)) return;
            const value = variant.options[optionIndex];
            if (typeof value !== 'string' || value.trim() === '') return;

            const normalizedValue = value.trim();
            if (!fallbackOptions.includes(normalizedValue)) {
              fallbackOptions.push(normalizedValue);
            }
          });
        });
      });

      if (fallbackOptions.length > 0) {
        options = fallbackOptions;
      }
    }

    let checkedCount = 0;

    let x = `<div class="c-collection-faceted-nav__facet-group" data-faceted-subnav>`;
    x += `<ul class="c-facets__list" role="list">`;

    options.forEach((option, i) => {
      let optionName = option;
      let checkboxId = `${this.filter.handle}-${i}`.replaceAll(' ', '-');
      this.isSelected(option) ? checkedCount++ : '';
      
      // Get product count for this option
      const productCount = FilterUtils.getProductCountForVariantOption(this.template.data.products || [], option, this.optionNames);

      x += `<li class="c-collection-faceted-nav__option o-heading--7" data-faceted-check-item>
        <input
          type="checkbox" class="c-facets__input is-checkbox c-collection-faceted-nav__option-input"
          data-index="${i}" data-option="${this.template.escape(option)}"
          data-facet-checkbox ${this.isSelected(option) ? 'checked' : ''}
          id="${checkboxId}"
        />
        <label for="${checkboxId}" class="c-facets__checkbox c-collection-faceted-nav__option-label">
          <span class="c-facets__checkbox-text">${optionName}</span>
          <span class="c-facets__option-count">(${productCount})</span>
        </label>
      </li>`;
    });

    x += `</ul></div>`;
  
    return x;
  }

}